import React from 'react'
import PropTypes from 'prop-types'

import LicenseRadio from '../license'
import getPhotoResolution from './photoResolution'
import { reportProductAddToCartAttempt } from '../../../../../common/analytics/resultAnalytics'
import { getTopLevelRoute } from '../../../../../common/utils/urlHelper'
import { logError } from '../../../../../common/utils/errors'
import setGATracker from '../../../../../common/utils/setGATracker'
import ShowMore from '../../showMore/showMore'
import Tags from '../tags'
import OkIcon from '../../../../shared/components/icons/ok'
import LoadingSpinner from '../../../../shared/components/icons/loadingSpinner'

import styles from './checkoutForm.module.css'

class CheckoutForm extends React.Component {
  constructor(props) {
    super(props)
    this.onLicenseChange = this.onLicenseChange.bind(this)
    this.onAddToCartClick = this.onAddToCartClick.bind(this)
    this.onCheckoutClick = this.onCheckoutClick.bind(this)

    this.state = {
      selectedLicense: Object.keys(props.licenses)[0],
      status: 'default'
    }
  }

  getLicensePrice(license) {
    const { support } = license
    return support[Object.keys(support)[0]].price
  }

  onLicenseChange(license) {
    this.setState({ selectedLicense: license })
  }

  onAddToCartClick() {
    const {
      item,
      licenses,
      addItemToCart,
      rank,
      currentSite,
      location
    } = this.props

    const { support } = licenses[this.state.selectedLicense]

    const topLevelRoute = getTopLevelRoute(location.pathname)

    const payload = {
      item_id: item.id,
      license_key: this.state.selectedLicense,
      support_key: Object.keys(support)[0]
    }

    setGATracker().then(gaClientId => {
      payload.ga_client_id = gaClientId
      this.setState({ status: 'locked' })

      addItemToCart(payload)
        .then(() => {
          this.setState({ status: 'default' })
          reportProductAddToCartAttempt(item, rank, currentSite, topLevelRoute)
        })
        .catch(err => {
          this.setState({ status: 'error' })
          logError(err)
        })
    })
  }

  onCheckoutClick(event) {
    event.preventDefault()
    window.location = `/cart/`
  }

  render() {
    const { item, licenses, cartEntries, rank } = this.props
    const { selectedLicense, status } = this.state

    const itemResolution = getPhotoResolution(item.photo_attributes)

    const formLocked = status === 'locked'
    const errorOccured = status === 'error'

    const cartHasItems = cartEntries && cartEntries.length > 0
    const currentItemInCart = cartHasItems
      ? cartEntries.reduce((acc, entry) => {
          return entry.item_id === item.id ? ++acc : acc
        }, 0)
      : 0

    return (
      <div className={styles.checkoutContainer}>
        <div className={styles.itemMetaContainer}>
          <div className={styles.itemMeta}>
            <p>
              <a
                href={`${item.url}?s_rank=${rank}`}
                className={styles.itemName}
              >
                {item.name}
              </a>
            </p>
            <p className={styles.itemAuthor}>
              <em>by </em>
              <a className={styles.itemAuthorLink} href={item.author_url}>
                {item.author_username}
              </a>
            </p>
          </div>
          <p className={styles.price}>
            {this.getLicensePrice(licenses[selectedLicense])}
          </p>
        </div>

        <div className={styles.licensePlaceholder}>
          <LicenseRadio
            selectedLicense={selectedLicense}
            onChange={this.onLicenseChange}
            licenses={licenses}
            disabled={formLocked}
          />

          {itemResolution && (
            <div className={styles.itemResolution}>
              Resolution: {itemResolution}
            </div>
          )}
        </div>

        <div className={styles.buttonsPlaceholder}>
          <button
            className={styles.addToCartButton}
            disabled={formLocked}
            onClick={this.onAddToCartClick}
          >
            {formLocked && (
              <LoadingSpinner
                width="20"
                height="20"
                strokeColor="hsl(0, 0%, 100%)"
              />
            )}
            {!formLocked && 'Add to Cart'}
          </button>

          {cartHasItems && (
            <button
              className={styles.goToCheckoutButton}
              disabled={formLocked}
              onClick={this.onCheckoutClick}
            >
              Go to Checkout
            </button>
          )}

          {currentItemInCart > 0 && (
            <div className={styles.itemAddedNotification}>
              <OkIcon width="20" height="16" className={styles.okIcon} />
              {`You have added ${
                currentItemInCart > 1
                  ? currentItemInCart + ' of this photo'
                  : 'this photo'
              } to your cart`}
            </div>
          )}

          {errorOccured && (
            <div className={styles.checkoutError}>
              This photo cannot be added to the cart. Please try later.
            </div>
          )}
        </div>

        <ShowMore
          linkClassName={styles.showMoreLink}
          linkExpandedClassName={styles.showMoreExpandedLink}
          showMoreLabel="See all tags"
          showLessLabel="See less tags"
        >
          <Tags tags={item.tags} />
        </ShowMore>
      </div>
    )
  }
}

CheckoutForm.propTypes = {
  item: PropTypes.object.isRequired,
  licenses: PropTypes.object.isRequired,
  rank: PropTypes.number.isRequired
}

export default CheckoutForm
